import dayjs from 'dayjs';
import { Trans, useTranslation } from 'react-i18next';
import { getTranslateName } from 'src/services/util';

export default function MyEndDateCard({ item }: { item: CheckoutUserProduct }): JSX.Element {
  const { t } = useTranslation();

  return (
    <div className="mt-3">
      <div className="min-h-40 border border-ice-blue rounded bg-white p-6 opacity-40 flex justify-between">
        <div className="pr-7">
          <div className="N_12_M text-brown-grey flex">
            <div>{t('product/my/finish')}</div>
            {/* <div className="w-4 flex justify-center items-center">
              <div className="oval-2"></div>
            </div> */}
            {/* <div>{t('product/my/coupon')}</div> */}
          </div>
          <div className="N_16_R text-black mt-5" style={{ wordBreak: 'keep-all' }}>
            {item[getTranslateName()]}
          </div>
          <div className="N_12_R text-brown-grey mt-1">
            <Trans i18nKey="product/my/service_period_date" values={{ date: dayjs(item.endDate).format('YYYY.MM.DD HH:mm') }}></Trans>
          </div>
          <div className="mt-2 flex flex-wrap items-center justify-start">
            <div className="N_12_R text-brown-grey flex-shrink-0">{t('product/my/payment_no')}</div>
            <div className="division mx-1.5"></div>
            <div className="N_12_R text-black">{item.displayPaymentId}</div>
          </div>
        </div>
        <div className="flex justify-center items-center">
          <div className="w-16 h-16 rounded-full bg-light-grey-blue text-white N_12_R flex justify-center items-center">
            {t('product/my/period_finish')}
          </div>
        </div>
      </div>
    </div>
  );
}
